<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="header-title">Advanced Data Table</h4> -->
            <p class="text-muted font-13 mb-0"></p>
            <!-- Table -->
            <div>
               <b-card-code >
                  <validation-observer ref="simpleRules">
                    <form @submit.prevent="submitForm">
                      <b-row>
                        <b-col md="4">
                          <b-form-group>
                            <label>Report Type</label>
                            <v-select
                            v-model="reporttype"
                            placeholder="None"
                            :options="[&quot;Bill Wise&quot;,&quot;Item Wise&quot; ]"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <label>Branch</label>
                            <v-select
                            v-model="branchname"
                            label="name"
                            placeholder="None"
                            :options="branchOptions"
                            @input="getEmployee()"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="4" v-if=" branchname.name=='Channel Partner' ||  branchname.name=='Franchise'">
                          <b-form-group>
                            <label>{{ branchname.name}}</label>
                            <v-select
                            v-model="employee"
                            label="name"
                            placeholder="None"
                            :options="employeeOptions"
                            @input="getSub()"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <label>Sub Employees</label>
                            <v-select
                            v-model="subemployee"
                            placeholder="None"
                            label="name"
                            :options="subemployeeOptions"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group>
                            <label>Supplier Name</label>
                              <v-select
                              v-model="suppliername"
                              placeholder="None"
                              label="name"
                              :options="supplierOptions"
                              />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <label>Approve Type</label>
                            <v-select
                            v-model="approvetype"
                            placeholder="None"
                            :options="[&quot;All&quot;,&quot;Pending&quot;,&quot;Approved&quot;,&quot;Reject&quot; ]"
                            />
                          </b-form-group>
                        </b-col>
                         <b-col md="4">
                          <b-form-group>
                            <label>Account Head</label>
                            <b-form-input
                            v-model="accounthead"
                            placeholder="Enter Account Head"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <label>Select Date</label>
                            <flat-pickr class="form-control"
                              value=""
                              placeholder="Select Date"
                              :config="{
                              dateFormat: 'd/m/Y',
                              mode: 'range',
                              }"
                              @input="getdata($event)"
                              style="background-color: transparent"/>
                          </b-form-group>
                        </b-col>

                      </b-row>
                      <div class="d-flex justify-content-end">
                        <b-button  variant="primary" class="ml-2" @click="searchData">
                          <feather-icon icon="SearchIcon" class="mr-50" />
                          <span class="align-middle">Search</span>
                        </b-button>
                      </div>
                    </form>
                  </validation-observer>
              </b-card-code>
              <report-table
                :data="data"
                :columns="fields"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/components/axios'
import BCardCode from '@core/components/b-card-code'
import flatPickr from 'vue-flatpickr-component'
import ReportTable from '../../../components/ReportTable.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import moment from 'moment'
import vSelect from 'vue-select'
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormTextarea,
  BFormDatepicker,
  BImgLazy
} from 'bootstrap-vue'
const baseApi = process.env.VUE_APP_APIENDPOINT
export default {
  components: {
    vSelect,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    BCardCode,
    ReportTable
  },
  data () {
    return {
      branchOptions:[{name:'Channel Partner', id:'channelpartner'}, {name:'Franchise', id:'franchise'}, {name:'Admin', id:'admin'}],

      startdate: '',
      enddate: '',
      branchname: '',
      suppliername: '',
      approvetype: '',
      reporttype: '',
      accounthead: '',
      data: '',
      subemployee: '',
      accessToken: localStorage.getItem('accessToken'),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      subemployeeOptions:[],
      employeeOptions:[],
      subemployeeOptions:[],
      supplierOptions:[],
      fields: [
        { field: 'id', label: 'S.R. No', hidden: true, filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'invoiceno', label: 'Invoice No', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'invoicedate', label: 'Invoice Date', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'Producrtype', label: 'Product Type', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'partyname', label: 'Party Name', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'ledgername', label: 'Ledger Name', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'hsncode', label: 'HSNCODE', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'qty', label: 'Qty', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'uom', label: 'UOM', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'rate', label: 'Rate', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'disc', label: 'disc', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'Amount', label: 'amount', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'cgst', label: 'CGST %', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'cgstamount', label: 'CGST Amount', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'sgst', label: 'SGST %', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'sgstamount', label: 'SGST Amount', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'igst', label: 'IGST %', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'igstamount', label: 'IGST Amount', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'cess', label: 'CESS %', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'cessamount', label: 'CESS Amount', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'pf', label: 'P & F', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'freigst', label: 'Freigst', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'roundoff', label: 'Round Off', filterOptions: {enabled: true, placeholder: 'Search'} },
        { field: 'grandtotal', label: 'Grand Total', filterOptions: {enabled: true, placeholder: 'Search'} }
      ]
    }
  },
  mounted () {
    this.getSupllier()
  },
  methods: {
    async getSupllier () {
      await axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.accessToken}`
        },
        url: `${this.baseApi}/ledger`
      })
        .then((response) => {
          this.supplierOptions = response.data.data.data
        })
    },
    async getEmployee () {
      this.employee = '',
      this.subemployeeOptions = [],
      this.subemployee = ''
      if (this.branchname.name == 'Channel Partner') {
        await axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.accessToken}`
          },
          url: `${this.baseApi}/getChannelpartner`
        })
          .then((response) => {

            this.employeeOptions = response.data.data
          })
      } else if (this.branchname.name == 'Franchise') {
        await axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.accessToken}`
          },
          url: `${this.baseApi}/getFranchise`
        })
          .then((response) => {
            this.employeeOptions = response.data.data
          })
      } else if (this.branchname.name == 'Admin') {
        await axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.accessToken}`
          },
          url: `${this.baseApi}/getUsers`
        })
          .then((response) => {
            this.subemployeeOptions = response.data.data
          })
      }
    },
    getSub () {
      this.subemployeeOptions = []
      this.subemployee = ''
      this.employeeOptions.map((item) => {
        if (item.parent == this.employee.id) {
          this.subemployeeOptions.push(item)
        }
      })
    },
    getdata (selectedDates) {
      this.result = selectedDates.split(' to ')
      this.startdate = this.result[0]
      this.enddate = this.result[1]
    },
    async getDropdowns () {
      this.formOptions.inputFields.map(async (item) => {
        if (item.type == 'dropdown' && item.url) {
          const requestOptionsUsers = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${accessToken}`
            },
            url: `${baseApi}/${item.url}`
          }

          await axios(requestOptionsUsers)
            .then((response) => {
              response.data.data.data
                ? (item.options = response.data.data.data)
                : (item.options = response.data.data)
            })
            .catch((error) => console.log(error, 'error'))
        }
      })
    },
    async searchData (tableData) {
      const data = {
        startdate:this.startdate,
        enddate:this.enddate,
        branch:this.branchname.id,
        employee_id:this.subemployee.id,
        suppliername: this.suppliername.id,
        approvetype: this.approvetype,
        reporttype: this.reporttype,
        acchead: this.accounthead
      }
      await axios({
        method:'POST',
        headers:{
          'Content-Type':'application/json',
          'Authorization': `Bearer ${this.accessToken}`
        },
        data:JSON.stringify(data),
        url:`${this.baseApi}/otherpurchasereport`
      })
        .then((response) => {
          this.data = response.data.data
        })
    }
  }
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
